<template>
  <div class="ViewLessonContent">
    <AppHeader content="课程管理|查看课程"></AppHeader>
    <AppBox class="appBox">
      <!-- 标题-->
      <div class="boxTitle">
        <div>制作课程</div>
      </div>
      <!--AppBox-->
      <div class="contentBox">
        <!--左边表格-->
        <div class="leftContent">
          <!--循环的每一个大纲模块-->
          <div
              class="itemOutLine"
              v-for="(item, index) in outLineArr"
              :key="item.id"
          >
            <div class="outLineBtn">
              {{ item.module }}
            </div>
            <div class="table">
              <XTable
                  ref="table"
                  v-if="stateArr && stateArr[index]"
                  :state="stateArr[index]"
                  :columns="columns"
                  :loading="lessonContentListLoading"
                  :tableSize="tableSize"
                  :maxHeight="maxHeight"
                  :layout="layout"
              ></XTable>
            </div>
          </div>
        </div>
        <!--                右边手机模型-->
        <div class="rightContent">
          <div>
            <IPhoneModelContainer ref="iPhoneModelContainer"></IPhoneModelContainer>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-button style="width: 20%" type="primary" @click="handleClose"
        >关闭
        </el-button>
      </div>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapState} from "vuex";
import {MODULE_TYPE} from "@/utils/constants";
import IPhoneModelContainer from "@/components/ui/IPhoneModelContainer/index.vue";

export default {
  name: "ViewLessonContent",
  components: {
    IPhoneModelContainer,
    XTable,
    AppBox,
    AppHeader,
  },
  data() {
    const columns = [
      {
        prop: "sequence",
        label: "序号",
      },
      {
        prop: "id",
        label: "编号",
      },
      {
        label: "角色",
        render(h, scope) {
          return (
              <div>
                <span>{[scope.row.content.role]}</span>
              </div>
          );
        },
      },
      {
        label: "形式",
        render(h, scope) {
          return (
              <div>
                <span>{MODULE_TYPE[scope.row.type]}</span>
              </div>
          );
        },
      },
    ];
    return {
      lessonId: null,
      modelItem: null,
      hasPagination: false,
      tableSize: "small",
      maxHeight: 30000,
      layout: "",
      stateArr: [],
      outLineArr: [],
      columns: [...columns],
    };
  },
  computed: {
    ...mapState("courseCenter", [
      "lessonContentListLoading",
      "lessonContentList",
      "editOutLineDetail",
    ]),
  },
  async mounted() {
    await this.getLessonEditOutline({
      id: Number(this.$Base64.decode(this.$route.params.lessonId)),
    });
    await this.initTable();
  },
  methods: {
    ...mapActions("courseCenter", ["getLessonContent", "getLessonEditOutline"]),
    // 初始化表格
    async initTable() {
      await this.$refs.iPhoneModelContainer.getDataFromFa(this.editOutLineDetail.lessonId, this.editOutLineDetail.version);
      // 根据大纲id获取大纲内容
      this.lessonId = this.editOutLineDetail.lessonId;
      this.outLineArr = this.editOutLineDetail.outline;
      this.modelItem = this.editOutLineDetail.outline[0];

      const res = await this.getLessonContent({
        lessonId: this.lessonId,
        version: this.editOutLineDetail.version,
      });
      this.stateArr = res.data;
    },
    async handleClose() {
      await this.$router.push(
          {
            name: "CourseList",
            params: {
              classSubjectId: this.$route.params.classSubjectId,
              classSubjectName: this.$route.params.classSubjectName,
            },
          },
          () => {
          }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.ViewLessonContent {
  overflow: hidden;

  .appBox {
    width: 100%;
    min-height: calc(100vh - 155px);

    .boxTitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #666666;
    }

    .contentBox {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      .rightContent {
        height: calc(100vh - 322px);
        width: 30%;
        display: flex;
        justify-content: center;
        margin-left: 10px;
      }

      .leftContent {
        width: 70%;
        box-shadow: -5px 5px 5px #f1f1f1;
        padding: 20px;
        height: calc(100vh - 322px);
        overflow-y: auto;

        .itemOutLine {
          display: flex;
          align-items: flex-start;

          .table {
            width: 100%;
          }

          .outLineBtn {
            text-align: center;
            background: #e7f0f5;
            min-width: 100px;
            border-radius: 3px;
            color: #10689c;
            border: 1px solid #10689c;
            padding: 8px;
            cursor: pointer;
            margin-right: 20px;
            margin-bottom: 20px;
          }
        }
      }
    }

    .footer {
      margin-top: 20px;
      width: 60%;
      text-align: center;
    }
  }
}
</style>
